import moment from "moment-timezone";

const HistoryListRenderer = ({ noteHistories }: { noteHistories: any[] }) => {
  return (
    <>
      {noteHistories.map((history: any, index: number) => (
        <div
          key={history.createdDate + index}
          style={{
            display: "flex",
            gap: 8,
            alignItems: "start",
            height: 200,
            border: "1px solid #ddd",
            borderRadius: 8,
            overflowY: "auto",
            padding: 14,
          }}
        >
          <div style={{ fontSize: "14px" }}>
            {moment(history.createdDate).format("MM/DD/YYYY")}:
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: history.newValue ?? "",
            }}
            style={{
              flex: 1,
              overflowY: "auto",
            }}
          ></div>
        </div>
      ))}
    </>
  );
};

export default HistoryListRenderer;
